import React from "react";
import './App.css';
import BookDetailsComponent from "./components/BookDetailsComponent";


function App() {
   return (
    <BookDetailsComponent />
  );
}

export default App;
